import {Component} from '@angular/core';
/**
 * \@title Basic toolbar
 */
export class ToolbarOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'toolbar-overview-example',
  templateUrl: 'toolbar-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ToolbarOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
ToolbarOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ToolbarOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
